import { Mail } from 'lucide-vue-next'
import type { App } from 'vue'

export * from './store'

export const createPlatformInvitations = () => ({
  install: (app: App) => {
    app.getRouter().addRoute('admin', {
      path: 'invitations',
      name: 'admin-platform-invitations',
      meta: {
        head: { titleKey: 'platformInvitations.title' },
        nav: { icon: Mail, order: 1 },
        crumbs: [{ labelKey: 'nav.admin' }, { labelKey: 'platformInvitations.title' }]
      },
      component: () => import('./pages/PlatformInvitationsPage.vue')
    })
  }
})
